//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
// import { mapGetters, mapMutations, mapActions } from 'vuex'
import Domel from '~/components/domel.vue'

// let _editor = null;

export default {
	// name: 'rest-rich-text',

	components:
	{
		Domel,
	},

	props:
	{
		// maxlength:
		// {
		// 	type: Number,
		// 	default: 0
		// },

		editable:
		{
			type: Boolean,
			default: false
		},

		tag:
		{
			type: String,
			default: 'span'
		},

		url:
		{
			type: String,
			default: ''
		},

		field:
		{
			type: String,
			default: ''
		},

		html:
		{
			type: String,
			default: null,
		},

		// saveHtml:
		// {
		// 	type: Boolean,
		// 	default: false
		// },

		modelId:
		{
			type: Number,
			default: -1,
		}
	},

	// data()
	// {
	// 	return {
	// 		content: null,
	// 	}
	// },

	computed:
	{
		filteredHtml()
		{
			if (this.tag.indexOf('h')==0)
			{
				let html = this.html || '';
				html = html.split('</p><p>').join('<br/>')
							.replace(/<p>/g, '')
							.replace(/<\/p>/g, '');

				return html;
			}

			return this.html;
		}
	},

	// watch:
	// {

	// },

	mounted ()
	{
		// debugger
		// this.content = this.html;
		consola.debug('rest-rich-text-dummy html: ', this.html)
	},


	// methods:
	// {

	// },

}
